import { useState, useEffect } from 'react';

/**
 * Hook for fetching hiring data for a conversation
 * @param {number} conversationId - Conversation ID
 * @returns {Object} Hiring data, loading state, and error
 */
const useFetchHiringData = (conversationId) => {
  const [hiringData, setHiringData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHiringData = async () => {
      if (!conversationId) {
        setHiringData(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/hirings/conversation/${conversationId}`,
          {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data) {
            setHiringData(data.data);
          } else {
            setHiringData(null);
          }
        } else if (response.status === 404) {
          setHiringData(null);
        } else {
          setError('Error fetching hiring data');
          setHiringData(null);
        }
      } catch (error) {
        setError(error.message);
        setHiringData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchHiringData();
  }, [conversationId]);

  return {
    hiringData,
    setHiringData, 
    loading,
    error
  };
};

export default useFetchHiringData;

